import React, { useState, useEffect } from "react";
import SlidePanel from "../add_customer/SlidePanel";
import { X } from "lucide-react";

const NewMobile = ({
  id_R,
  isNewMobileOpen,
  setIsNewMobileOpen,
  newMobileno,
  setNewMobileno,
  customerEditDetails,
  setOtpMobileOpen,
  handleNewPhoneNumber,
  setMobilePromptOpen,
}) => {
  const [phoneError, setPhoneError] = useState("");

  useEffect(() => {
    if (isNewMobileOpen) {
      setNewMobileno(customerEditDetails?.mobileno || "");
    }
  }, [isNewMobileOpen, customerEditDetails, setNewMobileno]);

  const validatePhoneNumber = (number) => {
    if (!number) {
      setPhoneError("");
      return false;
    }

    if (number?.startsWith("0") && number?.length !== 10) {
      setPhoneError("Phone number starting with 0 must be 10 digits");
      return false;
    }

    if (number?.startsWith("254") && number?.length !== 12) {
      setPhoneError("Phone number starting with 254 must be 12 digits");
      return false;
    }

    if (number?.startsWith("+254") && number?.length !== 13) {
      setPhoneError("Phone number starting with +254 must be 13 characters");
      return false;
    }

    if (
      !number?.startsWith("0") &&
      !number?.startsWith("254") &&
      !number?.startsWith("+254")
    ) {
      setPhoneError("Phone number must start with 0, 254 or +254");
      return false;
    }

    setPhoneError("");
    return true;
  };

  const handlePhoneChange = (e) => {
    let value = e.target.value;

    value = value.replace(/(?!^\+)[^\d]/g, "");

    if (value.startsWith("+254")) {
      value = "+" + value?.slice(1)?.replace(/\D/g, "").slice(0, 12);
    } else if (value.startsWith("254")) {
      value = value.replace(/\D/g, "").slice(0, 12);
    } else if (value.startsWith("0")) {
      value = value.replace(/\D/g, "").slice(0, 10);
    }

    setNewMobileno(value);

    if (value.length > 0) {
      validatePhoneNumber(value);
    } else {
      setPhoneError("");
    }
  };

  const isPhoneValid =
    !!newMobileno &&
    !phoneError &&
    ((newMobileno?.startsWith("0") && newMobileno?.length === 10) ||
      (newMobileno?.startsWith("254") && newMobileno?.length === 12) ||
      (newMobileno?.startsWith("+254") && newMobileno?.length === 13));

  const handleClose = () => {
    setIsNewMobileOpen(false);
  };

  const handleBackButton = () => {
    handleClose();
    setMobilePromptOpen(true);
  };

  return (
    <SlidePanel isOpen={isNewMobileOpen} onClose={handleClose}>
      <div className="relative flex flex-col h-full bg-white rounded-[12px]">
        <div
          onClick={handleClose}
          className="absolute top-0 right-0 cursor-pointer h-[40px] w-[40px] bg-[#FF0000] rounded-tr-[10px] rounded-bl-[20px] flex items-center justify-center z-10"
        >
          <X color="#ffffff" />
        </div>

        <div className="flex flex-col h-full">
          <div className="p-5">
            <div className="flex items-center">
              <p className="text-[20px] font-bold text-[#000] mt-8">
                Enter new phone number
              </p>
            </div>

            <p className="text-[#000] text-[15px] mt-5">
              Please enter the member’s new primary phone number for the
              verification process.
            </p>

            <div className="flex flex-col h-[50vh] mt-12">
              <div className="flex w-[98%] flex-col">
                <label className="mb-5">Phone Number</label>

                <input
                  type="text"
                  value={newMobileno}
                  onChange={handlePhoneChange}
                  className={`w-full rounded px-3 py-3 bg-[#EAEAEA] border focus:outline-none ${
                    phoneError ? "border-red-500" : "border-[#EAEAEA]"
                  }`}
                />

                {phoneError && (
                  <p className="text-red-500 text-[13px] mt-2">{phoneError}</p>
                )}
              </div>
            </div>

            <div className="flex items-center w-full mx-auto text-white justify-between">
              <button
                onClick={handleBackButton}
                className="px-10 py-3  bg-[#7FB8EA] rounded-[5px] text-[#000]"
              >
                Back
              </button>

              <button
                onClick={handleNewPhoneNumber}
                disabled={!isPhoneValid}
                className={`px-8 py-3 rounded-[5px] text-[#FFFFFF] transition-all duration-200 ${
                  isPhoneValid
                    ? "bg-[#074073] cursor-pointer"
                    : "bg-[#D9D9D9] cursor-not-allowed"
                }`}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    </SlidePanel>
  );
};

export default NewMobile;
